import React from "react";
import { withStyles } from "@material-ui/core";
import ConfirmationModal from "features/shared/components/confirmationModal";
import { ReportOutlined } from "@material-ui/icons";
import { useTranslations } from "adapters/i18n";

function ExitModal({ onSubmit, onCancel, classes }) {
  const { t } = useTranslations();
  const titleComponent = (
    <div className={classes.title}>
      <ReportOutlined />
      {t("planning:register.exit.title")}
    </div>
  );

  return (
    <ConfirmationModal
      title={titleComponent}
      text={t("planning:register.exit.text")}
      submitButtonTitle={t("planning:register.exit.submit")}
      classNames={{
        cancelButtonClass: classes.cancelButtonClass,
        submitButtonClass: classes.submitButtonClass,
      }}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  );
}

const styles = () => ({
  title: {
    display: "flex",
    gap: "8px",
    "& svg": {
      fill: "#EB394B",
    },
  },
  cancelButtonClass: {
    border: "unset",
    color: "#333",
  },
  submitButtonClass: {
    border: "unset",
    backgroundColor: "unset",
    color: "#EB394B",
  },
});

export default withStyles(styles)(ExitModal);
